<template>
  <div class="signature">
    <div class="signature-title" v-if="init != true">
      <Alert type="warning">请手写签名，并确认！</Alert>
      <Button @click="initSign" ghost size="small" type="primary">使用已录签名</Button>
    </div>
    <div class="signatureAera" ref="signatureAera">
      <esign :direction="direction" :height="width" :width="height" ref="esign" />
    </div>
    <div class="agree">
      <Button @click="resetSign" ghost shape="circle" type="primary">重签</Button>
      <Button @click="sign" shape="circle" type="primary">确认</Button>
    </div>
    <Spin fix v-if="showSpan">
      <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
      <div>上传中，请稍候...</div>
    </Spin>
  </div>
</template>

<script>
import esign from './esign-panel/esign'
export default {
  name: "esignPanel",
  props: {
    direction: {
      type: String,
      default: "horizontal", //"vertical"
    },
    init: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: "h5"
    }
  },
  components: {
    esign
  },
  data () {
    return {
      showSpan: false,
      width: 0,
      height: 0,
    }
  },
  methods: {
    initSign () {
      // 获取历史签名，成功后进行回显
      let that = this
      if (this.source == 'h5') {
        this.$axiosH5.get(that.$apis.msgManageApi.getSign).then(res => {
          if (res.success && res.result) {
            this.$refs.esign.initSing(res.result)
          } else {
            this.$Message.warning("未找到已录入签名")
          }
        }).catch(function (err) {
          that.$Message.error("获取信息失败！")
        })
      } else {
        this.$axios.get(that.$apis.systemManager.userManager.getSign).then(res => {
          if (res.success && res.result) {
            this.$refs.esign.initSing(res.result)
          } else {
            console.log("未找到已录入签名")
          }
        }).catch(function (err) {
          that.$Message.error("获取信息失败！")
        })
      }
    },
    resetSign () {
      this.$refs.esign.reset()
    },
    sign () {
      let that = this
      this.showSpan = true
      if (this.source == 'h5') {
        this.$refs.esign.generate().then((res) => {
          // 更新签名，成功后跳转页
          let params = new this.$URLSearchParams()
          params.append('signBase64', res)
          that.$axiosH5.post(this.$apis.msgManageApi.updateSign, params).then((data) => {
            if (data.success) {
              this.$emit('sign', res)
            } else {
              that.$Message.error(res.message)
            }
          }).catch((err) => {
            that.$Message.error(err.message)
          })
        }).catch((err) => {
          that.$Message.error("请先进行签名")
        }).finally(() => {
          that.showSpan = false
        })
      } else {
        this.$refs.esign.generate().then((res) => {
          // 更新签名，成功后跳转页
          let params = new this.$URLSearchParams()
          params.append('signBase64', res)
          that.$axios.post(this.$apis.systemManager.userManager.updateSign, params).then((data) => {
            if (data.success) {
              this.$emit('sign', res)
            } else {
              that.$Message.error(res.message)
            }
          }).catch((err) => {
            that.$Message.error(err.message)
          })
        }).catch((err) => {
          that.$Message.error("请先进行签名")
        }).finally(() => {
          that.showSpan = false
        })
      }

    },
  },
  beforeMount () {
    this.$nextTick(() => {
      this.width = this.$refs.signatureAera.width
      this.height = this.$refs.signatureAera.height
      if (this.init) this.initSign()
    })
  }
};
</script>

<style lang="less">
.signature {
  width: 100%;
  height: 100%;

  min-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .signature-title {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }
  .title {
    color: #363a44;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    font-family: 'PingFang SC';
    line-height: 22px;
  }
  .initbtn {
    height: 26px;
    border-radius: 4px;
    border: 1px solid #0366f1ff;
    background: #f3f5f9ff;
    color: #0366f1ff;
    font-size: 12px;
    font-weight: 400;
    font-family: 'PingFang SC';
    text-align: left;
    line-height: 18px;
  }
  .signatureAera {
    flex-grow: 1;
    background-color: #f3f5f9;
    // width: 351px;
    // height: calc(100vh - 160px);
    // background-color: #fff;
  }

  .agree {
    // position: fixed;
    // height: 96px;
    padding: 10px;
    width: 100%;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    // text-align: right;
    > button {
      width: 45%;
    }
  }
}
</style>
